import { isVNode } from 'element-ui/lib/utils/vdom'
export default {
  props: ['value'],
  render(h) {
    const { value } = this
    return typeof value === 'function' ? value(h) : (isVNode(value) ? (value) : h('div', value, this.$slots.default))
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-guide/steps-item.js